export default "__VITE_ASSET__2szVg7MA__"